import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export const exportToExcelJS = async (rows, columns, filename = 'Exported_data') => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Feuille1');
  // Définir les colonnes avec entêtes
  worksheet.columns = columns.map(col => ({
    header: col.headerName,
    key: col.field,
    width: col.width ? col.width / 7 : 20 
  }));

  // Style de l'en-tête
  const headerRow = worksheet.getRow(1);
  headerRow.eachCell(cell => {
    cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF4F81BD' } // bleu foncé
    };
    cell.alignment = { vertical: 'middle', horizontal: 'center' };
    cell.border = {
      top: { style: 'thin' },
      bottom: { style: 'thin' },
      left: { style: 'thin' },
      right: { style: 'thin' }
    };
  });

  // Ajouter les données
  rows.forEach(row => {
    const rowData = {};
    columns.forEach(col => {
      rowData[col.field] = row[col.field];
    });
    worksheet.addRow(rowData);
  });

  // Générer et télécharger
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/octet-stream' });
  saveAs(blob, `${filename}.xlsx`);
};
